// Which documents a Trust UBO must supply.
//
// Lives outside useRightSidebar.js so the Corporate Structure and Management Structure
// document builders share one definition, and so the rule is testable on its own.
//
// Two documents used to be requested for every Trust unconditionally, which was wrong:
//  - "passports for the Trustees": a Corporate Trustee is a company and has no passport.
//    trusteeTypeDocuments already asks the correct documents for each trustee type
//    (Corporate Trustee / Legal Person / Natural Person), so no blanket ask is needed.
//  - beneficiary ID and proof of address: only possible where beneficiaries are named.

// Trust types where trustForm.js collects "Full Name of Beneficiaries" — these have
// identifiable people. The rest (Discretionary, Accumulation Trust, Charitable Trust,
// Pension Trust) collect a "Class of Beneficiaries" instead, so there is nobody to
// identify. Keep in sync with trustForm.js.
export const BENEFICIARY_ID_TRUST_TYPES = ["Bare Trust", "Non-resident Trust"];

// ponytail: a doc key IS the storage identity of an upload, so the stale
// "(if defined benefit trust)" wording stays — renaming it would orphan files already
// uploaded against the old key. Rename only together with a migration.
export const BENEFICIARY_DOCS = [
  "Certified copy passports (or other appropriate ID) for the Beneficiaries (if defined benefit trust)",
  "Proof of address for the Beneficiaries",
];

export const beneficiaryDocKeys = (prefix, uboType, uboData) => {
  if (uboType !== "Trust") return [];
  if (!BENEFICIARY_ID_TRUST_TYPES.includes(uboData?.uboTrustType)) return [];
  return BENEFICIARY_DOCS.map((doc) => `${prefix} - ${doc}`);
};
